import { useEffect, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import {
  CouponListDiv,
  HeaderTitle,
  OffersListHeader,
  SeeMore,
} from './styled';
import OfferNewDesignInner from '../../Product/OfferCarousel/OfferNewDesignInner';

function GeneralItemOfferDesign(props) {
  const {
    offerList,
    eventHandler,
    productPrice,
    couponCodeOffers,
    showNewDiaperVariantUx,
    userType,
    removeBottomMargin,
    horizontalOnDesktopView,
  } = props;

  const [isDesktopView, setIsDesktopView] = useState(false);

  useEffect(() => {
    if (horizontalOnDesktopView) {
      const updateView = () => {
        if (window.innerWidth > 720) {
          setIsDesktopView(true);
          initialCountShow = offerCount;
        } else if (window.innerWidth < 720) {
          setIsDesktopView(false);
        }
      };
      // Run once on mount
      updateView();

      // Add a resize listener
      window.addEventListener('resize', updateView);

      // Cleanup listener on unmount
      return () => window.removeEventListener('resize', updateView);
    }
  }, []); // No window dependency here, safe for SSR

  let initialCountShow = 1;
  let cocoIndex = -1;
  offerList?.map((offer, index) => {
    if (offer.term_id == 6795) cocoIndex = index;
  });

  if (cocoIndex != -1) {
    offerList.splice(cocoIndex, 1);
  }
  let offerListNew = offerList;

  if (couponCodeOffers) {
    const data = [];
    data.push(couponCodeOffers);
    offerListNew = [...data, ...offerListNew];
  }
  offerListNew = [
    ...new Map(offerListNew.map((item) => [item['term_id'], item])).values(),
  ];

  const offerCount = offerListNew?.length;

  function getInitialCount() {
    return offerCount >= initialCountShow ? initialCountShow : offerCount;
  }

  const [initialOfferSize, setInitialOfferSize] = useState(getInitialCount());
  const [countShownOffers, setCountShownOffers] = useState(initialOfferSize);

  const getCurrentValue = () => {
    const moreOffers = countShownOffers !== offerCount;
    if (moreOffers) {
      return {
        text: `See ${offerCount - countShownOffers} More`,
        value: 'More',
      };
    } else {
      return { text: 'See Less', value: 'Less' };
    }
  };
  const showButton = () => {
    return offerCount !== initialOfferSize;
  };
  const onExpandContractOfferHandler = (state) => {
    const value = state.value;
    switch (value) {
      case 'More':
        setCountShownOffers(offerCount);
        break;
      case 'Less':
        setCountShownOffers(initialOfferSize);
        break;
    }
  };
  const getTopText = () => {
    if (offerCount === 1) {
      return '1 Offer Available';
    } else {
      return `${offerCount} Offers Available`;
    }
  };

  useEffect(() => {
    let initialCount = getInitialCount();
    setInitialOfferSize(initialCount);
    setCountShownOffers(initialCount);
    const params = new URLSearchParams(window.location.search);
  }, [offerList]);

  return (
    <CouponListDiv
      showMargin={offerListNew?.length > 0 ? true : false}
      removeBottomMargin={removeBottomMargin}
      horizontalOnDesktopView={horizontalOnDesktopView}
    >
      {offerCount > 0 && !showNewDiaperVariantUx ? (
        <OffersListHeader horizontalOnDesktopView={horizontalOnDesktopView}>
          <HeaderTitle>{getTopText()}</HeaderTitle>
        </OffersListHeader>
      ) : null}

      {!isDesktopView ? (
        <>
          <ul className="coupon_list">
            {offerListNew?.map((data, index) => {
              return (
                <ScrollWrapper
                  // data={impressionData}
                  threshold={0.8}
                  key={`offer_${index}`}
                >
                  <OfferNewDesignInner
                    productPrice={productPrice}
                    key={`offer_${index}`}
                    data={data}
                    eventHandler={eventHandler}
                    index={index}
                    countShownOffers={countShownOffers}
                    showButton={showButton}
                    // showNewOfferTitle={showNewOfferTitle}
                    userType={userType}
                  />
                </ScrollWrapper>
              );
            })}
          </ul>
          {showButton() && (
            <div
              onClick={() => {
                onExpandContractOfferHandler(getCurrentValue());
              }}
            >
              <SeeMore>
                <span>{getCurrentValue()?.text}</span>
                <img
                  src={images.arrowdownforward}
                  className={getCurrentValue()?.value == 'Less' ? 'rotate' : ''}
                  alt="down_arrow"
                />
              </SeeMore>
            </div>
          )}
        </>
      ) : (
        <ul className="coupon_list_desktop">
          {offerListNew?.map((data, index) => {
            return (
              <ScrollWrapper
                // data={impressionData}
                threshold={0.8}
                key={`offer_${index}`}
              >
                <OfferNewDesignInner
                  productPrice={productPrice}
                  key={`offer_${index}`}
                  data={data}
                  eventHandler={eventHandler}
                  index={index}
                  countShownOffers={countShownOffers}
                  showButton={showButton}
                  // showNewOfferTitle={showNewOfferTitle}
                  userType={userType}
                />
              </ScrollWrapper>
            );
          })}
        </ul>
      )}
    </CouponListDiv>
  );
}

export default GeneralItemOfferDesign;
